<template>
  <div class="serviceCasePage">
    <img src="../assets/ServiceCase/banner.jpg" alt="" class="banner">
    <div class="serviceCaseContent">
    <div class="casePanel">
      <div class="title1">上海程多多电子商务有限公司专注企业差旅16年，凭借丰富的产品资源、专业的服务团队与强大技术团队，服务领域</div>
      <div class="title2">涵盖食品制造、服装、美容、金融、重工业等，代表企业有</div>
      <div class="caseList">
        <img src="../assets/ServiceCase/case1.png" alt="">
        <img src="../assets/ServiceCase/case2.png" alt="">
        <img src="../assets/ServiceCase/case3.png" alt="">
        <img src="../assets/ServiceCase/case4.png" alt="">
        <img src="../assets/ServiceCase/case5.png" alt="">
        <img src="../assets/ServiceCase/case6.png" alt="">
        <img src="../assets/ServiceCase/case7.png" alt="">
        <img src="../assets/ServiceCase/case8.png" alt="">
        <img src="../assets/ServiceCase/case9.png" alt="">
        <img src="../assets/ServiceCase/case10.png" alt="">
      </div>
    </div>
    <div class="chineseTitle">上海程多多电子商务有限公司荣幸首批入选政府机票采购供应商</div>
    <div class="englishTitle">— GOVERNMENT TICKET PURCHASE PROVIDER —</div>
    <div class="providerTitle">
      <div class="text">为贯彻落实《党政机关厉行节约反对浪费条例》要求，规范公务机票购买行为</div>
      <div class="text">为更好的落实执行《财政部、外交部关于印发 <i class="el-icon-arrow-left"></i>因公临时出国经费管理办法<i class="el-icon-arrow-right"></i>的通知》</div>
      <div class="text">（财行 （2013 ）516号）及政府采购相关制度规定</div>
      <div class="text">中国财政部和民用航空局经过严格的审核，筛选出全国政府机票采购供应商</div>
    </div>
    <div class="serviceExperience">
      <div class="content">
        <div class="leftDiv">
          服务经验
        </div>
        <div class="rightDiv">
          <div class="guaranteeDiv">
            <img src="../assets/ServiceCase/guaranteeIcon.png" alt="">
            <div class="remark1">已为公务行提供</div>
            <div class="remark2">9年服务保障</div>
          </div>
          <div class="trophyDiv">
            <img src="../assets/ServiceCase/trophyIcon.png" alt="">
            <div class="remark1">公务出行服务业绩</div>
            <div class="remark2">超过平均水平</div>
          </div>
        </div>
      </div>
    </div>
    <div class="serviceContent">
      <div class="content">
        <div class="leftDiv">
          服务内容
        </div>
        <div class="rightDiv">
          <div class="contentItem">
            <div class="subTitle">客票类型</div>
            <div class="titleItem">国内机票</div>
            <div class="titleItem">国际机票</div>
          </div>
          <div class="contentItem">
            <div class="subTitle">客户类型</div>
            <div class="titleItem">散客</div>
            <div class="titleItem">协议客户</div>
          </div>
          <div class="contentItem">
            <div class="subTitle">支付方式</div>
            <div class="titleItem">公务卡</div>
            <div class="titleItem">对公转账</div>
            <div class="titleItem">支票</div>
          </div>
          <div class="contentItem">
            <div class="subTitle">支付账期</div>
            <div class="titleItem">现结</div>
            <div class="titleItem">后付</div>
          </div>
          <div class="contentItem">
            <div class="subTitle">报销凭据</div>
            <div class="titleItem">快递邮寄</div>
            <div class="titleItem">现场领取</div>
          </div>
        </div>
      </div>
    </div>
    <div class="minTitle">雀巢全资子公司—太太乐战略合作16年</div>
    <div class="redTitle">节省费用30%以上</div>
    <img src="../assets/ServiceCase/companyBg.png" alt="" class="companyBg">
    <div class="companyProfile">
      <span>客户简介</span>
      上海太太乐食品有限公司作为雀巢全资子公司，创立于1988年，是中国调味品行业三强企业之一销售网络覆盖全国各地，并出口至美国、加拿大、日本、中东等国家和地区
    </div>
    <div class="companyProfile">
      <span>合作背景</span>
      太太乐集团全国各地拥有营销公司，尤其集团法务部、督导部、重点客户部、高管总监等每月出差频率特别高，对机票需求量大
    </div>
    <div class="companyProfile">
      <span>合作模式</span>
      随着太太乐企业差旅需求不断增加，由人工定制差旅服务升级到智能化差旅管理系统
    </div>
    <div class="ARBox">
      <div class="artificialDiv">
        <div class="introduction">
          <div class="title">人工定制化差旅管理服务</div>
          <div class="content">企业指定行政人员对接专属差旅顾问</br>沟通机票、酒店、改签等需求</div>
        </div>
      </div>
      <div class="intelligentDiv">
        <div class="introduction">
          <div class="title">智能化差旅管理系统</div>
          <div class="content">企业统一账户，并导入太太乐差旅政策 分配员工账号，出差人员自行订票</div>
        </div>
      </div>
    </div>
    <div class="leftRed">合作成果</div>
    <div class="redPanel1">
      <div class="div1">
        <div class="title">费用节省至少30%</div>
        <div class="text">年均节省至少10万</div>
        <div class="text">费用节省18%左右</div>
        <div class="text">全流程管控节省费用12%左右</div>
      </div>
      <div class="div2">
        <div class="title">提高行政、财务出差人员工作效率</div>
        <div class="text">简化行政工作</div>
        <div class="text">降低财务做账难度</div>
        <div class="text">节省出差人员时间</div>
      </div>
    </div>
    <div class="minTitle">为日本神户钢铁提供</div>
    <div class="redTitle">智能化差旅系统+一对一专属服务</div>
    <img src="../assets/ServiceCase/smartTravel.png" alt="" class="smartTravel">
    <div class="companyProfile">
      <span>客户简介</span>
      日本神户钢铁是日本第三大钢铁联合企业，创建于1905年，1960年开启了全球化发展的新纪元，迄今业务涵盖钢铁、机械、工程、房地产等多个领域，并设立多家海外办事机构
    </div>
    <div class="companyProfile">
      <span>合作背景</span>
      日本神户钢铁作为规模较大的外企，企业出差频繁，尤其是国际日本航线的需求，作为日本企业，要求全日语服务
    </div>
    <div class="cooperationModel">
      <div class="titleSpan">合作模式</div>
      <div class="contentDiv m1">
        <div class="rightDiv">
          <div class="title">智能化差旅管理系统</div>
          <div class="introduction">开通企业账户，出行员工自行订票</div>
        </div>
      </div>
    </div>
    <div class="leftRed">合作成果</div>
    <div class="redPanel2">
      <div class="div1">
        <div class="title">产品价格优惠，每年节省15%左右</div>
        <div class="text">上海程多多电子商务有限公司协助日本神户钢铁</div>
        <div class="text">享受机票最优价格</div>
      </div>
      <div class="div2">
        <div class="title">全流程管控，节省13%左右</div>
        <div class="text">规范员工差旅行为；领导随时线上审批</div>
        <div class="text">简化审批流程，财务差旅费用核对，提供效率</div>
      </div>
      <div class="div3">
        <div class="title">全程日语服务，保障顺利出行</div>
        <div class="text">专属国际差旅服务团队，及时解决出行问题</div>
        <div class="text">保障人员顺利出行</div>
      </div>
    </div>
    <div class="minTitle">及时专业的定制差旅服务</div>
    <div class="redTitle">深受美丽田园褒扬</div>
    <div class="travelServicesImgList">
      <img src="../assets/ServiceCase/travelServicesBg.png" alt="">
      <img src="../assets/ServiceCase/certificate.png" alt="">
    </div>
    <div class="companyProfile">
      <span>客户简介</span>
      上海美丽田园美容发展有限公司旗下美丽田园（Beauty Farm）首家门店创立于1993年，引进德国丹妮嘉（DEYNIQUE）公司美容院线品牌进入中国，先后在北京、上海等105个城市的中心区域开设了近400家专业美容连锁中心
    </div>
    <div class="companyProfile">
      <span>合作背景</span>
      美丽田园在全国一二线城市商业中心、购物中心等设有门店，全国各地设有分公司，并与德国知名美容院有合作关系，对国际国内机票、国际国内酒店、签证等需求大
    </div>
    <div class="cooperationModel">
      <div class="titleSpan">合作模式</div>
      <div class="contentDiv m2">
        <div class="rightDiv">
          <div class="title">人工定制化差旅服务</div>
          <div class="introduction">美丽田园安排专属差旅经理对接需求</div>
          <div class="introduction">上海程多多电子商务有限公司配备专属差旅顾问一对一对接</div>
        </div>
      </div>
    </div>
    <div class="leftRed">合作成果</div>
    <div class="redPanel3">
      <div class="div1">
        <div class="title">专业服务，快速解决客户需求</div>
        <div class="text">上海程多多电子商务有限公司专属服务小组，服务专业、及时、周到</div>
        <div class="text">帮助客户提供一站式企业差旅服务，保证领导员工出差的满意度</div>
      </div>
      <div class="div2">
        <div class="title">规范员工差旅行为，节省费用</div>
        <div class="text">通过上海程多多电子商务有限公司第三方差旅服务商</div>
        <div class="text">不断规范员工差旅行为，节省不必要的开支</div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ServiceCase',
    data() {
      return {}
    },
    methods: {}
  }
</script>

<style lang="less" scoped>
  @import "../css/ServiceCase.less";
</style>



// WEBPACK FOOTER //
// src/pages/ServiceCase.vue